import {format} from "date-fns";
import {useEffect, useRef} from "react";
import {useFormContext} from "react-hook-form";

import {useCurrentUserContext} from "@/components/context/hooks.ts";
import {InputField} from "@/components/form/fields/InputField/InputField.tsx";
import {DateFormatDateFns, DateFormatName} from "@/lib/types/common.ts";

export const DEFAULT_NAME_PLACEHOLDER = "Maintenance on --/--/--";

export const MaintenanceNameField = () => {
  const {watch, setValue, getValues} = useFormContext();
  const {user} = useCurrentUserContext();
  const startDate = watch("start_date");
  const nameValue = watch("name");

  const nameManuallyEdited = useRef(false);
  const lastAutoName = useRef(DEFAULT_NAME_PLACEHOLDER);
  const initialized = useRef(false);

  const dateFormat = DateFormatDateFns[user!.current_date_format ?? DateFormatName.DEFAULT];

  useEffect(() => {
    if (!initialized.current) {
      initialized.current = true;
      const initialName = getValues("name");
      if (initialName && initialName !== DEFAULT_NAME_PLACEHOLDER && initialName !== lastAutoName.current) {
        nameManuallyEdited.current = true;
      }
    }
  }, [getValues]);

  useEffect(() => {
    if (
      initialized.current &&
      nameValue &&
      nameValue !== DEFAULT_NAME_PLACEHOLDER &&
      nameValue !== lastAutoName.current &&
      !nameManuallyEdited.current
    ) {
      nameManuallyEdited.current = true;
    }
  }, [nameValue]);

  useEffect(() => {
    if (startDate instanceof Date && !isNaN(startDate.getTime()) && !nameManuallyEdited.current) {
      const autoName = `Maintenance on ${format(startDate, dateFormat)}`;
      lastAutoName.current = autoName;
      setValue("name", autoName, {shouldValidate: true});
    }
  }, [startDate, setValue, dateFormat]);

  const handleNameChange = () => {
    const currentName = getValues("name");
    if (currentName !== lastAutoName.current) {
      nameManuallyEdited.current = true;
    }
  };

  return (
    <InputField
      name="name"
      required
      label="Name"
      placeholder="Enter Maintenance Schedule name"
      options={{onChange: handleNameChange}}
    />
  );
};
